module.exports = __webpack_public_path__ + "img/clickfunnels_3.b8791910.png";